'use client';

import type { ReactNode } from 'react';
import { useState } from 'react';

interface TooltipComponentProps {
	label?: string;
	onClickLabel?: string;
	dataCy?: string;
	children?: ReactNode;
}

function Tooltip({ label = '', onClickLabel = '', dataCy, children }: TooltipComponentProps) {
	const [tooltipText, setTooltipText] = useState<string>(label ? label : onClickLabel);
	const [clicked, setClicked] = useState<boolean>(false);

	const delay = (ms: number) => {
		return new Promise((resolve) => {
			setTimeout(resolve, ms);
		});
	};

	return (
		<div
			className="group relative inline-block w-full"
			onClick={() => {
				setTooltipText(onClickLabel ? onClickLabel : label);
				setClicked(true);
			}}
			onMouseLeave={async () => {
				setClicked(false);
				await delay(150);
				setTooltipText(label ? label : onClickLabel);
			}}
		>
			<span
				className={`pointer-events-none absolute bottom-[150%] left-1/2 z-10 w-fit -translate-x-1/2 scale-90 rounded-md bg-black px-3 py-1.5 text-center text-white opacity-0 transition ease-in after:absolute after:left-1/2 after:top-full after:-translate-x-1/2 after:border-4 after:border-solid after:border-x-transparent after:border-b-transparent after:border-t-black after:content-[''] ${
					label || (clicked && onClickLabel) ? 'group-hover:scale-100 group-hover:opacity-100' : ''
				}`}
				data-cy={dataCy}
			>
				{tooltipText}
			</span>
			{children}
		</div>
	);
}

export default Tooltip;
